/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsVideoIntroViewProps } from '../../../modules/hosports-video-intro/./hosports-video-intro';
import VideoIntro from "./../../../baseComponents/video-intro/./video-intro";

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsVideoHeroViewProps>}
 */
 class HosportsVideoIntro extends React.Component<IHosportsVideoIntroViewProps> {

   public render(): JSX.Element {
     const { config } = this.props;

     return (
       <VideoIntro
         video={config.video}
         showSkipButton={config.showSkipButton}
         setCookie={config.setCookie}
         cookieValue={config.cookieValue}
       />
     );
   }
 }

export default HosportsVideoIntro;
